<template>
    <div class="modal-content">
        <template v-if="scoreDetail[0].technicalDatas&&Object.keys(scoreDetail[0].technicalDatas).length>1">
            <div class="content">
                <div class="once-column">
                    <div class="empty"></div>
                    <div  class="race-name" v-for="(round,index) in scoreDetail" :key="index">{{round.rounds}} {{round.victory}}</div>
                </div>
                <div class="coach">
                    <div class="column-name">
                        <template v-for="(key,value) in scoreDetail[0].technicalDatas">
                            <div class="name-cell"  :key="value" v-if="value!='得分'">{{value}}</div>
                        </template>
                    </div>      
                    <div class="column" v-for="(roundScores,row) in scoreDetail" :key="row">
                        <template v-for="(key,value) in roundScores.technicalDatas">
                        <div class="column-cell" @click="handleScoreDetail(roundScores,j)" :class="key.redScore==1?'cell-red':'cell-blue'" :key="value" v-if="value!='得分'?value:''">{{key.redScore==1?key.redScore:key.blueScore}}</div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="explain">END</div>
        </template>
        <template v-else>
            <div class="score-empty">
                <a-empty  style="width:100%;">
                    <span slot="description"> 暂无数据分析 </span>
                </a-empty>
            </div>
        </template>
    </div>
</template>

<script>
export default {
  name:'StreeModalContent',
  props:['scoreDetail','allData'],
  data () {
    return {
    }

  },
  computed: {
    name () {
      return this.data 
    }
  },
  mounted () {
  },
  methods: {
    handleScoreDetail (roundScores,i) {
      // 详情请求接口参数封装
      let scoreDetailData={}
      scoreDetailData.round=roundScores.round
      scoreDetailData.fromRefee=roundScores.roundScores[i].fromRefee
      scoreDetailData.pkId=this.allData.pkId
      scoreDetailData.scoreModle=this.allData.scoreModle
      //分数不为空切换详情组件
      if(roundScores.roundScores[i].score){
        scoreDetailData.isDetail=true
        this.$emit('handleChangeDetail',scoreDetailData)
      }else{
        this.$message.warning('暂无分数')
      }
    }
      
  },
}
</script>

<style lang="scss" scoped>
.modal-content{
    .content{
        width: 1100px;
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        .once-column{
            width: 120px;
            .race-name{
                width: 120px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                font-weight: bold;
                color: #333333;
                margin-top: 10px;
            }
            .empty{
                width: 120px;
                height: 50px;
                line-height: 50px;
                margin-top: 10px;
            }
        }
        //教练
        .coach{
            display: flex;
            width: 100%;
            flex-direction: column;
            // justify-content: space-evenly;
            .column-name{
                text-align: center;
                font-weight: bold;
                color: #333333;
                // line-height: 80px;
                // height: 80px;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                .name-cell{
                      width: 100%;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    margin-top: 10px;
                    font-weight: bold;
                    font-size: 16px;
                }
            }
            .column{
                width: 100%;
                display: flex;
                justify-content: space-evenly;
                .column-cell{
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    margin-right: 10px;
                    margin-top: 10px;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 16px;
                }
                .cell-blue{
                    background-color: #2364B9;
                }
                .cell-red{
                    background-color: #D53F48;
                }
            }
            

        }   
        
    }
.explain{
        width: 1100px;
        height: 30px;
        line-height: 80px;
        font-size: 14px;
        color: #888888;
        font-weight: Medium;
        text-align: center;
    }
}
  //分数空样式
  .score-empty{
    width: 100%;
    height: 420px;
    text-align: center;
    line-height: 420px;
    display: flex;
    align-items: center;
    flex: 1;
  }
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/military/content/SampleContent.vue